/* Opens and closes the "This language isn't supported yet" dialog
   (partial/unsupported-language-modal). The tools call
   window.openUnsupportedLanguageModal() when the service turns a text down
   for its language; the form inside is the newsletter's (newsletter.js), and
   it sends the language and the tool along, so the person can hear when that
   tool supports that language. Someone already subscribed gets no form, only
   a line that says so and a Notify me button, which sends the same request
   with the address they subscribed with.

   While the dialog is open the focus stays in it (Tab and Shift+Tab go round
   its controls); when it closes, the focus goes back to the tool's text. */
(function () {
    'use strict';

    var modal = document.getElementById('unsupportedLanguageModal');
    if (!modal) return;

    var form = modal.querySelector('.js-newsletter-form');
    var notify = modal.querySelector('.lang-modal-notify');
    var noted = modal.querySelector('.lang-modal-noted');
    var returnFocus = null;
    var notifying = false;

    // the same check /subscribe makes (NewsletterLanguageRequest::record):
    // a language the detection could not settle on is not recorded
    var LANGUAGE = /^[a-z]{2,3}(?:-[a-z0-9]{2,8})?$/;

    function field(name) {
        return form && form.querySelector('input[name="' + name + '"]');
    }

    function setField(name, value) {
        var input = field(name);
        if (input) input.value = value ? String(value).trim().toLowerCase() : '';
    }

    function isOpen() {
        return modal.classList.contains('modal-open');
    }

    function close() {
        if (!isOpen()) return;
        modal.classList.remove('modal-open');
        modal.hidden = true;
        document.body.classList.remove('modal-open');
        if (returnFocus && document.contains(returnFocus)) returnFocus.focus({ preventScroll: true });
        returnFocus = null;
    }

    // what Tab can reach in the dialog now: shown, and not switched off
    function focusables() {
        return Array.prototype.filter.call(
            modal.querySelectorAll('a[href], button, input, [tabindex]:not([tabindex="-1"])'),
            function (el) {
                return !el.disabled && el.type !== 'hidden' && el.getClientRects().length > 0;
            }
        );
    }

    /* options.language: the code of the language the service found in the
       text ("pl"); options.tool: humanizer, paraphraser, grammar, writer or
       detector; options.returnFocus: where the focus goes when the dialog
       closes — the tool's text field. The element that had the focus before
       is the default. */
    window.openUnsupportedLanguageModal = function (options) {
        options = options || {};
        returnFocus = options.returnFocus || document.activeElement;

        setField('requested_language', options.language);
        setField('tool', options.tool);
        // a subscription made for the last language must not stand in for
        // this one: the form starts over
        if (form) form.dispatchEvent(new CustomEvent('newsletter:reset'));
        /* Already subscribed: an account that said yes (.is-subscribed), or
           a browser that subscribed in the last three months (newsletter.js).
           Then the dialog shows "You're already subscribed" in place of the
           offer, the form and its privacy line (.is-known). Decided here, on
           open, so a subscription made in the open dialog keeps its thanks. */
        var subscribed = modal.classList.contains('is-subscribed')
            || document.documentElement.classList.contains('nl-subscribed');
        modal.classList.toggle('is-known', subscribed);

        // Notify me starts over too, and shows only for a language that can
        // be recorded
        var language = field('requested_language');
        notifying = false;
        if (notify) {
            notify.hidden = !(language && LANGUAGE.test(language.value));
            notify.disabled = false;
        }
        if (noted) noted.hidden = true;

        modal.classList.add('modal-open');
        /* ios-cleaner.js drops hidden as well, but only after this script is
           done; the old styles of the embedded humanizer hide [hidden] with
           !important, and a hidden field cannot take the focus below. */
        modal.hidden = false;
        document.body.classList.add('modal-open');

        /* The e-mail field is what the dialog is for, but on a touch screen
           focusing it brings up the keyboard over the dialog before it was
           read. There the cross takes the focus instead, and so it does when
           the field is hidden for someone already subscribed. */
        var email = modal.querySelector('input[type="email"]');
        var target = !subscribed && email && !email.disabled && window.matchMedia('(pointer: fine)').matches
            ? email
            : modal.querySelector('.modal-close');
        if (target) target.focus({ preventScroll: true });
    };

    /* Notify me: the hidden form goes out once more. An account that said yes
       sends its own address (the form has it); a browser that subscribed
       sends the address it subscribed with. */
    if (notify && form) {
        notify.addEventListener('click', function () {
            var email = field('email');
            var saved = window.newsletterSavedEmail ? window.newsletterSavedEmail() : '';
            if (email && saved && !modal.classList.contains('is-subscribed')) email.value = saved;

            notifying = true;
            notify.disabled = true;
            // a disabled button drops the focus; the dialog keeps it
            modal.querySelector('.modal-close').focus({ preventScroll: true });
            form.dispatchEvent(new Event('submit', { cancelable: true }));
        });

        form.addEventListener('newsletter:done', function () {
            if (!notifying) return;
            notifying = false;
            notify.hidden = true;
            if (noted) {
                noted.hidden = false;
                noted.focus({ preventScroll: true });
            }
        });

        // the reason shows in the form's note (.is-known lets an error
        // through); the button is ready for another try
        form.addEventListener('newsletter:failed', function () {
            if (!notifying) return;
            notifying = false;
            notify.disabled = false;
            notify.focus({ preventScroll: true });
        });
    }

    modal.addEventListener('click', function (event) {
        if (event.target.closest('.modal-close') || !event.target.closest('.modal-content')) close();
    });

    document.addEventListener('keydown', function (event) {
        if (!isOpen()) return;
        if (event.key === 'Escape') {
            close();
            return;
        }
        if (event.key !== 'Tab') return;

        /* Tab goes round the dialog's own controls. The focus can also sit
           on a message (tabindex -1) or, after a click, outside the
           controls: from there Tab starts at the first and Shift+Tab at the
           last. */
        var items = focusables();
        if (!items.length) return;
        var index = items.indexOf(document.activeElement);
        var next = null;
        if (index === -1) next = event.shiftKey ? items[items.length - 1] : items[0];
        else if (!event.shiftKey && index === items.length - 1) next = items[0];
        else if (event.shiftKey && index === 0) next = items[items.length - 1];
        if (next) {
            event.preventDefault();
            next.focus();
        }
    });
})();
